/* Recast: light-state switch for the hero (warm / colour). */
(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-rc-switch]').forEach(function (sw) {
      if (sw.dataset.ready) return;
      sw.dataset.ready = '1';
      var stage = sw.closest('[data-rc-stage]');
      if (!stage) return;
      var media = stage.querySelectorAll('[data-rc-media]');
      var buttons = sw.querySelectorAll('[data-rc-to]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var to = btn.getAttribute('data-rc-to');
          media.forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-rc-media') === to); });
          buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          stage.setAttribute('data-state', to);
        });
      });
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
